import EventEmitter from 'event-emitter';
import ToolOption from '../common/ToolOption';
/**
 * 抽象基类
 *
 * @export
 * @class Graphic
 * @author zhenliang.sun
 * @date 2018-05-02 11:02:10
 */
export default class Graphic {
  constructor(app) {
    EventEmitter(this);
    this.app = app;
  }

  start() {
    this.addEvents();
  }

  stop() {
    this.removeEvents();
  }

  addEvents() {}

  removeEvents() {}

  get defaultOption() {}

  /**
   * 进行设置，通常是颜色，内容，线条宽度等
   *
   * @param {any} opt
   * @memberof Graphic
   */
  set option(opt) {
    // if (!this._option) {
    //   this._option = new ToolOption();
    // }
    this._option = opt;
  }

  set app(val) {
    this._app = val;
  }

  get app() {
    return this._app;
  }

  get option() {
    return this._option;
  }

  /**
   * 获取Canvas对象
   *
   * @readonly
   * @memberof Graphic
   */
  get root() {
    return this.app.canvas;
  }

  get stage() {
    return this.app.stage;
  }

  get items() {
    return this.app.items;
  }

  /**
   * 获取工厂实例
   *
   * @readonly
   * @memberof Graphic
   */
  get factory() {
    return this.app.graphicFactory;
  }

  // 这并不是一个完整的数据， 需要子类进行后续加工
  static toAddData(target) {
    let obj = {};
    obj.type = target.type;
    obj.uuid = target.uuid;
    obj.uniqueID = Date.now();
    obj.left = parseFloat(target.left.toFixed(1));
    obj.top = parseFloat(target.top.toFixed(1));
    obj.stroke = target.stroke;
    obj.strokeWidth = parseFloat(target.strokeWidth);
    obj.width = parseFloat(target.width.toFixed(1));
    obj.height = parseFloat(target.height.toFixed(1));
    return obj;
  }

  static toModifyData(target) {
    let obj = {};
    obj.uuid = target.uuid;
    obj.uniqueID = Date.now();
    obj.left = parseFloat(target.left.toFixed(1));
    obj.top = parseFloat(target.top.toFixed(1));
    obj.scaleX = parseFloat(target.scaleX.toFixed(3)) * (target.flipX ? -1 : 1);
    obj.scaleY = parseFloat(target.scaleY.toFixed(3)) * (target.flipY ? -1 : 1);
    obj.angle = parseFloat(target.angle.toFixed(1));
    return obj;
  }
}
